import React, { Component } from 'react';
import DownTriangleSmall from 'sushiweb/Icons/all/DownTriangleSmall'

class DropdownComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showMenu: false
    }
  }

  handleSelect(ele) {
    this.setState({
      selectedFilter: {
        key: ele.key,
        value: ele.value,
        sendValue: ele.sendValue
      },
      showMenu: false
    }, () => {
      this.props.handleClick(this.state.selectedFilter)
    });
  }

  listenEvent = (e) => {
    let isEnableClick = (e.target.matches('.dropdown-wrapper') || e.target.matches('.dropdown-custom') || e.target.matches('.dropdown-head'));
    if (!isEnableClick) {
      this.setState({ showMenu: false });
    }
  }

  componentDidMount() {
    window.addEventListener('click', this.listenEvent)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.listenEvent)
  }

  handleMenuState = (event) => {
    event.stopPropagation();
    const { showMenu } = this.state;
    this.setState({showMenu: !showMenu})
  }

  render() {
    const { menu, defaultParam, primary, displayName, displayKeyName,isUploaded } = this.props;
    const { showMenu } = this.state;
    return (
      <React.Fragment>
        <div className={primary ? `dropdown-wrapper dropdown-wrapper-primary ${this.props.className}` :  `dropdown-wrapper dropdown-filter-wrapper ${this.props.className}`} onClick={(event) => this.handleMenuState(event) }>
          <div className="dropdown-custom">
            <div className="dropdown-head">{!displayName ? defaultParam.value :  displayName}</div>
            {
              showMenu && 
              <div className="dropdown-content">
                {menu.map((ele, index) => {
                    return(
                      <div 
                        className={ele.value == defaultParam.value ? "dropdown-ele active" : "dropdown-ele"} 
                        onMouseDown={() => this.handleSelect(ele)}
                        key={index}
                      >{ !displayKeyName ? ele.value : ele[displayKeyName]}</div>
                    )
                  })
                }
              </div>
            }
            { isUploaded !== true &&  <DownTriangleSmall />}
          </div>
          
        </div>
      </React.Fragment>
    )
  }
}

export default DropdownComponent;
